export default __webpack_public_path__ + "static/media/visa-fifa-wc2022.21db1186.png";